/* eslint-disable no-case-declarations */
/* eslint-disable import/order */
import domready from 'domready';
import setupScrollTo from './modules/scroll-to';
import { setupGalleries, setupSwipers } from './modules/setup-swipers';

import { controlMenuDropdowns } from './modules/control-header-dropdowns';
import { setupDataLayer } from './modules/dataLayer';
import { setupDestinations } from './modules/destinations';
import {
  setupDialogs,
  setupFetchDialogs,
  setupVideoDialogs,
} from './modules/dialogs';
import setupHeader from './modules/header';
import { setupLockingForms } from './modules/locking-form';
import { setupMaps } from './modules/map';
import { setupObscureJs } from './modules/obscure';
import { offlineBookingForm } from './modules/offline-booking-form';
import setupPhotoswipes from './modules/photoswipe';
import setupReadMore from './modules/readmore';
import setupLoadMore from './modules/setup-load-more';
import { setupSliders } from './modules/setup-sliders';
import setupStickyHeader from './modules/sticky-header';
import { setupTriggers } from './modules/triggers';
import { setupUTMInputs } from './modules/utms';

// Lazysizes
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/respimg/ls.respimg';

// React / redux
import React from 'react';
import { createRoot } from 'react-dom/client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { store } from './modules/store';
import AccommodationListing from './react/components/AccommodationListing';
import ActivityListing from './react/components/ActivityListing';
import BrochureForm from './react/components/BrochureForm';
import ButtonBerndDatesPrices from './react/components/ButtonBerndDatesPrices';
import ContactForm from './react/components/ContactForm';
import DeparturesListing from './react/components/DeparturesListing';
import DesignMyTripForm from './react/components/DesignMyTripForm';
import Favourite from './react/components/Favourite';
import FavouriteCount from './react/components/FavouriteCount';
import HolidayFinder from './react/components/HolidayFinder';
import HolidayListing from './react/components/HolidayListing';
import NewsletterFormFooter from './react/components/NewsletterFormFooter';
import NewsletterFormPopup from './react/components/NewsletterFormPopup';
import OnlineBooking from './react/components/OnlineBooking';
import Places from './react/components/Places';
import Reviews from './react/components/Reviews';
import Wishlist from './react/components/Wishlist';
import Wrapper from './react/components/Wrapper';

function isJsAvailable() {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');
}

// So I just wanted to add a class to the body with a slight delay so that any animations
// that might be a bit skewiff on page load can be delayed. e.g. the dropdown fading out as
// page loads
function enableAnimations() {
  setTimeout(() => {
    document.documentElement.classList.add('animations-enabled');
  }, 200);
}

function submitBrochure() {
  const callback = (e) => {
    // e.stopPropagation();
    const form = e.target.closest('.c-contact__form--brochures');
    const checkboxGroup = form.querySelector('.c-form__checkbox-group');
    const inputs = checkboxGroup.querySelectorAll('input');
    let anyChecked = false;

    inputs.forEach((input) => {
      if (input.checked) anyChecked = true;
    });

    if (anyChecked) {
      form.submit();
    } else {
      e.preventDefault();
      inputs[0].setCustomValidity('Please select at least one brochure');
      form.reportValidity();
    }
  };

  const brochureFormsSubmitButtons = document.querySelectorAll(
    '.c-contact__form__submit'
  );

  // const brochures = document.querySelectorAll('.c-contact__form');

  brochureFormsSubmitButtons.forEach((button) => {
    button.addEventListener('click', callback);
  });

  // brochures.querySelectorAll('inputs').forEach((form) => {
  //   form.addEventListener([(type = 'checkbox')], (e) => {});
  // });
}

// setup react
// Setup React roots
function setupReact() {
  // Base class names for react to target.  One for each component IE ListingApp renders at .listing-root
  const rootsClassNames = [
    '.root--activities-listing',
    '.root--accommodation-listing',
    '.root--departures-listing',
    '.root--holiday-listing',
    '.root--holiday-listing--holiday-styles',
    '.root--interactive-map',
    '.root--contact-form',
    '.root--brochures-form',
    '.root--design-my-trip-form',
    '.root--newsletter-form-popup',
    '.root--newsletter-form-footer',
    '.root--holiday-finder',
    '.root--itinerary-overview',
    '.root--places',
    '.root--wishlist',
    '.root--reviews',
    '.root--favourite',
    '.root--favourite-count',
    // '.root--opening-status--mobile',
    // '.root--opening-status--tablet',
    // '.root--opening-status--desktop',
    // '.root--opening-status',
    '.root--button-bernd-dates-prices',
  ];

  rootsClassNames.forEach((rootClassName) => {
    const componentLocations = document.querySelectorAll(rootClassName);
    // Render a react instance for every root of this name on the page
    componentLocations.forEach((location) => {
      const root = createRoot(location);
      switch (rootClassName) {
        case '.root--online-booking':
          root.render(
            <Wrapper>
              <OnlineBooking />
            </Wrapper>
          );
          break;
        // case '.root--opening-status--mobile':
        //   root.render(
        //     <Wrapper>
        //       <OpeningStatus viewport="mobile" />
        //     </Wrapper>
        //   );
        //   break;
        // case '.root--opening-status--tablet':
        //   root.render(
        //     <Wrapper>
        //       <OpeningStatus viewport="tablet" />
        //     </Wrapper>
        //   );
        //   break;
        // case '.root--opening-status--desktop':
        //   root.render(
        //     <Wrapper>
        //       <OpeningStatus viewport="desktop" />
        //     </Wrapper>
        //   );
        //   break;
        case '.root--activities-listing':
          root.render(
            <Wrapper>
              <ActivityListing />
            </Wrapper>
          );
          break;
        case '.root--accommodation-listing':
          root.render(
            <Wrapper>
              <AccommodationListing />
            </Wrapper>
          );
          break;
        case '.root--departures-listing':
          root.render(
            <Wrapper>
              <DeparturesListing
                holidayId={location.getAttribute('data-holidayId')}
              />
            </Wrapper>
          );
          break;
        case '.root--holiday-listing':
          root.render(
            <Wrapper>
              <HolidayListing />
            </Wrapper>
          );
          break;
        case '.root--holiday-listing--holiday-styles':
          root.render(
            <Wrapper>
              <HolidayListing holidayStyles={true} />
            </Wrapper>
          );
          break;
        case '.root--contact-form':
          root.render(
            <Wrapper>
              <ContactForm />
            </Wrapper>
          );
          break;
        case '.root--brochures-form':
          root.render(
            <Wrapper>
              <BrochureForm />
            </Wrapper>
          );
          break;
        case '.root--design-my-trip-form':
          root.render(
            <Wrapper>
              <DesignMyTripForm />
            </Wrapper>
          );
          break;
        case '.root--newsletter-form-footer':
          root.render(
            <Wrapper>
              <NewsletterFormFooter />
            </Wrapper>
          );
          break;
        case '.root--newsletter-form-popup':
          root.render(
            <Wrapper>
              <NewsletterFormPopup />
            </Wrapper>
          );
          break;
        case '.root--wishlist':
          root.render(
            <Wrapper>
              <Wishlist />
            </Wrapper>
          );
          break;
        case '.root--holiday-finder':
          root.render(
            <Wrapper>
              <HolidayFinder />
            </Wrapper>
          );
          break;
        case '.root--places':
          root.render(
            <Wrapper>
              <Places />
            </Wrapper>
          );
          break;
        case '.root--reviews':
          root.render(
            <Wrapper>
              <Reviews />
            </Wrapper>
          );
          break;
        case '.root--favourite-count':
          root.render(
            <Wrapper>
              <FavouriteCount />
            </Wrapper>
          );
          break;
        case '.root--favourite':
          root.render(
            <Wrapper>
              <Favourite
                type={location.getAttribute('data-type')}
                id={location.getAttribute('data-id')}
                white={!!location.getAttribute('data-white')}
                additionalClass={location.getAttribute('data-class')}
              />
            </Wrapper>
          );
          break;
        case '.root--button-bernd-dates-prices':
          root.render(
            <Wrapper>
              <ButtonBerndDatesPrices
                classes="o-btn o-btn--tangerine"
                holidayId={location.getAttribute('data-holidayId')}
                contactLink={location.getAttribute('data-contactLink')}
              />
            </Wrapper>
          );
          break;
        default:
          break;
      }
    });
  });
}

window.store = store; // Redux store

function initialise() {
  isJsAvailable();
  controlMenuDropdowns();
  offlineBookingForm();
  setupStickyHeader();
  setupSliders();
  setupUTMInputs();
  setupHeader();
  setupScrollTo();
  setupSwipers();
  setupGalleries();
  setupTriggers();
  setupDialogs();
  setupFetchDialogs();
  setupVideoDialogs();
  enableAnimations();
  setupMaps();
  setupPhotoswipes();
  setupDestinations();
  setupReadMore();
  setupLoadMore();
  setupLockingForms();
  setupDataLayer();
  submitBrochure();
  setupObscureJs();
  setupReact();
  setupLockingForms();
}

const finalScripts = {
  init: initialise,
};

domready(() => {
  finalScripts.init();
});
